import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'

import {
  selectCategoriesMap,
  selectCategoriesIsLoading,
} from '../../store/categories/categorySelector'

import ProductCard from '../../components/product-card/ProductCard'
import Spinner from '../../components/spinner/Spinner'

import { CategoryContainer, Title } from './category.styles.js'

const Category = () => {
  const { category } = useParams()
  const categoriesMap = useSelector(selectCategoriesMap)
  const isLoading = useSelector(selectCategoriesIsLoading)
  const [products, setProducts] = useState(categoriesMap[category])

  useEffect(() => {
    setProducts(categoriesMap[category])
  }, [category, categoriesMap])

  return (
    <>
      <Helmet>
        <title>{category} page</title>
        <meta
          name='description'
          content='Showing all the products of a category'
        />
      </Helmet>
      <Title>{category.toUpperCase()}</Title>
      {isLoading ? (
        <Spinner />
      ) : (
        <CategoryContainer>
          {products &&
            products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
        </CategoryContainer>
      )}
    </>
  )
}

export default Category
